export default __webpack_public_path__ + "static/media/no-buyouts.e77cb21e.jpg";